export default "/images/candy-image-70.png?2bfef5a46d962eccf59bc10b9e84926d";